import { IVector } from "./IVector";

export interface IVectorCoordinatable<T = number> {
  vector: IVector<T>;
}

export function instanceOfIVectorCoordinatable<T = number>(instance: any): instance is IVectorCoordinatable<T> {
  return instance
      && (instance.vector !== undefined);
}
